import React from 'react'
import {
	Navbar, NavbarBrand, NavbarToggler, Nav, NavLink,
	Container, Collapse
} from 'reactstrap'

class HeaderNavbar extends React.Component {
	constructor(props) {
		super(props)
		this.toggle = this.toggle.bind(this)
		this.state = {
			isOpen: false
		}
	}

	toggle() {
		this.setState({
			isOpen: !this.state.isOpen
		})
	}

	render() {
	  const sections = [
	  	{url: '/about', name: 'About'},
	  	{url: 'http://eepurl.com/go_PLX', name: 'Subscribe'},
	  	{url: 'mailto:ryanshea@shea.io', name: 'Email'},
	  	{url: 'https://twitter.com/ryaneshea', name: 'Twitter'},
	  ]

		return (
			<div style={{ marginBottom: '1.45rem' }}>
		    <Navbar color="light" light expand="md">
		      <Container fluid style={{ paddingLeft: '0px' }}>
		        <NavbarBrand href="/">SHEA</NavbarBrand>
		        <NavbarToggler onClick={this.toggle} />
		        <Collapse isOpen={this.state.isOpen} navbar>
			        <Nav className="ml-auto" navbar>
							{sections.map(function(section) {
	        			return (
		  		    		<NavLink key={section.url} href={section.url}>
		  		    			{section.name}
		  		    		</NavLink>
	        			)
		        	})}
			        </Nav>
			       </Collapse>
		      </Container>
		    </Navbar>
		  </div>
		)
	}
}

export default HeaderNavbar

//	  	{url: '/archive', name: 'Archive'},
